import React, { useContext } from 'react';
import classnames from 'classnames';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import DesktopDevPageDisplayStage728x90 from '@wix/da-ads/pkg/adunits/DesktopDevPageDisplayStage728x90';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useDeviationViewContext } from '../../../Context';
import { useSelector } from 'react-redux';
import { getCurrentAdSafety } from '../../../Ads/redux/selectors';
import s from './StageContainer.scss';
export var StageContainer = function (_a) {
    var children = _a.children, className = _a.className;
    var adSafety = useSelector(function (state) { return getCurrentAdSafety(state); });
    var _b = useDeviationViewContext(), isTheater = _b.isTheater, isFullscreen = _b.isFullscreen;
    var adsEnabled = useContext(SessionContext).adsEnabled;
    var adsNitro = useFlag('ads_nitro');
    var showAd = adsEnabled && adsNitro;
    return (React.createElement("div", { className: classnames(s['root'], isTheater && s['theater'], isFullscreen && s['fullscreen'], showAd && s['with-ad'], className), "data-hook": BiDataHook.DEVIATION_ART_STAGE },
        showAd && (React.createElement("div", { className: s['ad-slot'] },
            React.createElement(DesktopDevPageDisplayStage728x90, { safety: adSafety }))),
        React.createElement("div", { className: s['stage-content'] }, children)));
};
StageContainer.displayName = 'StageContainer';
export default StageContainer;
//# sourceMappingURL=StageContainer.js.map